import './Pdf.scss';

export default function Pdf() {
  return (
    <svg className="Pdf" version="1.1" x="0px" y="0px" viewBox="0 0 76.7 101.9">
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        className="Pdf-group"
      >
        <g>
          <path
            d="M37.8,27.9l8.8-15.5C51.9,3.2,55.8,0,64.9,0h11.7v101.9H0V27.6c0-6.6,3.2-10.5,9.1-10.5c2.7,0,5.2,0.8,9.5,2.7L37.8,27.9z
           M7.5,48.2v21.2h5.6v-6.6h6.1c4.9,0,7.5-2.2,7.5-6.8v-1c0-4.6-2.7-6.8-7.5-6.8H7.5z M13.1,52.9h5.6c1.7,0,2.1,0.8,2.1,2.7
          c0,1.7-0.4,2.5-2.1,2.5h-5.6V52.9z M30,48.2v21.2h10.9c6,0,9.1-2.2,9.1-7.5v-6.1c0-5.3-3.1-7.5-9.1-7.5H30z M35.6,53.2h4.9
          c2.7,0,3.8,1,3.8,3.5v4.2c0,2.5-1.1,3.5-3.8,3.5h-4.9V53.2z M70.2,53.2v-5H54v21.2h5.6V62h10.6v-5H59.6v-3.8H70.2z"
          />
        </g>
      </g>
    </svg>
  );
}
